export default __webpack_public_path__ + "static/media/ils9150d.0f6f6f1d.png";